import { useEffect, useState } from 'react';
import DropdownMenu from './DropdownMenu';

const mapLinkAttributes = (item = {}) => {
  const { url, newWindow } = item;

  if (!url || item.tag === 'span') return {};

  const attrs = { href: url };

  if (newWindow) {
    attrs.target = '_blank';
    attrs.rel = 'noopener noreferrer';
  }

  return attrs;
};

export default function HeaderMoreNavigation({ items = [], mountEl = null }) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handlePrimaryOpen = () => setIsOpen(false);

    window.addEventListener('header:primary-dropdown-open', handlePrimaryOpen);
    const handleClickOutside = (event) => {
      if (!mountEl || !mountEl.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('header:primary-dropdown-open', handlePrimaryOpen);
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [mountEl]);

  useEffect(() => {
    if (!mountEl) return;
    if (isOpen) {
      mountEl.classList.add('g-header__primary-more--open');
    } else {
      mountEl.classList.remove('g-header__primary-more--open');
    }
  }, [isOpen, mountEl]);

  const menuItem = { title: 'More', children: items };

  return (
    <>
      <button
        className={isOpen ? 'g-header__primary-more-trigger g-header__primary-more-trigger--open' : 'g-header__primary-more-trigger'}
        type="button"
        aria-label="More menu"
        aria-expanded={isOpen}
        aria-haspopup="true"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="g-header__primary-more-hamburger" aria-hidden="true" focusable="false">
          <line y1="1" x2="21" y2="1" stroke="#000000" strokeWidth="2" />
          <line y1="6" x2="21" y2="6" stroke="#000000" strokeWidth="2" />
          <line y1="11" x2="21" y2="11" stroke="#000000" strokeWidth="2" />
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" className="g-header__primary-more-close" aria-hidden="true" focusable="false">
          <line x1="0.706956" y1="15.5546" x2="15.5562" y2="0.70537" stroke="#F8F8F7" strokeWidth="2" />
          <line y1="-1" x2="21" y2="-1" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 15.2617 16.2617)" stroke="#F8F8F7" strokeWidth="2" />
        </svg>

      </button>
      <DropdownMenu
        item={menuItem}
        baseKey="more"
        mapLinkAttributes={mapLinkAttributes}
        useGrid={false}
        isOpen={isOpen}
        allowNested={false}
        align="center"
        isCompact
        offset="spaced"
      />
    </>
  );
}
